// Generated from SVG to Code Figma Plugin

export const BaseLineExtractentrance = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect height="14" width="18" rx="2.4" stroke="currentColor" strokeLinejoin="round" strokeWidth="1.5" x="3" y="5" />
    <path d="M12 3L12 22" stroke="currentColor" strokeDasharray="3 3" strokeLinecap="round" strokeWidth="1.5" />
  </svg>
);
